import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06a910e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "marker-icon" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative cursor-pointer",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('click:station', {station: _ctx.station})), ["stop"]))
  }, [
    (!_ctx.selected)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: require('../../../img/map/marker-pin2.svg').default,
          width: "30"
        }, null, 8 /* PROPS */, _hoisted_1))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: require('../../../img/map/marker-pin-selected.svg').default,
          width: "30"
        }, null, 8 /* PROPS */, _hoisted_2)),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        _createElementVNode("img", {
          src: require('../../../img/map/elichens-logo-small-all-white.svg').default,
          width: "22",
          height: "22"
        }, null, 8 /* PROPS */, _hoisted_4)
      ], true)
    ])
  ]))
}